<template>
  <h1 class="d-flex justify-content-center title">404 Not Found</h1>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.title {
  margin-top: rem(40);
}
</style>
